module.exports = __webpack_public_path__ + "img/j3.216f5e0f.webp";